import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const SystemBaiscs = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
      const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
          setShowModal(false)
      }

    return (
        <>
            <section>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='gameflow button'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-rpg.png`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                    <p className=' '>
                        Phantom Brave: The Lost Hero features{' '}
                        <sapn className='text-pborange'>unrestricted movement</sapn> in combat! Characters can move
                        freely within a radius during battle.
                    </p>
                    <p className='mt-8'>
                        The game is turn-based, with friends and foes alike taking turns based on their Speed stat. You
                        can check the turn order on the upper right corner of the screen. Plan your strategy based on
                        who's up next!
                    </p>
                    <div className='flex flex-col md:flex-row gap-4 mt-8'>
                        <div className='w-full md:w-1/2'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'system', 1)
                                }}
                                className='ss-thumb'
                                alt='screen shot of game system'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-system-1-s.webp`}
                            />
                        </div>
                        <div className='w-full md:w-1/2'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'system', 2)
                                }}
                                className='ss-thumb'
                                alt='screen shot of game system'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-system-2-s.webp`}
                            />{' '}
                        </div>
                    </div>
                </div>{' '}
                <div className='flex justify-center mt-20'>
                    <img
                        className=''
                        alt='play'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-play.png`}
                    />
                </div>{' '}
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white px-4 md:px-0 w-full md:w-4/5 mx-auto mt-12'>
                    <p className=' '>
                        Equip items found on the battlefield, throw enemies in your way off the map entirely, stack
                        characters on top of each other to reach high places, and more — these are just some of the{' '}
                        <sapn className='text-pborange'>cutting-edge features on offer!</sapn>
                    </p>
                    <p className='mt-8'>
                        For example, by lifting up an ally, you can use that ally's skills, or even use the ally
                        themselves as a weapon! The wide array of possibilities is sure to{' '}
                        <sapn className='text-pborange'>stoke the player's imagination!</sapn>
                    </p>
                    <div className='flex mt-8'>
                        <div className='w-full md:w-3/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'system', 3)
                                }}
                                className='ss-thumb'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-system-3-s.webp`}
                            />
                        </div>
                    </div>
                </div>{' '}
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={3}
                />
            </section>
        </>
    )
}
